import React from "react";
import { set } from "dot-prop-immutable";
import { connect } from "react-redux";
import {
  SimpleForm as Form,
  Switch,
  Collapse,
} from "@whalecloud/fdx";
import {
  toolFormAttr,
  toolCollapseAttr,
} from "@utils/util";
import WidthSetting from "@whalecloud/page-builder-base-components/components/ElementSettings/WidthSetting";
import GridSettings from "@whalecloud/page-builder-base-components/components/ElementSettings/CommonGridSettings";
import {
  getElementWithChildren,
  getParentElementWithChildren,
} from "@whalecloud/page-builder-core/selectors";
import isEqual from "lodash/isEqual";
import { getLocale } from "@utils/util";

const { Panel } = Collapse;
const valueKey = "data.componentSettings";
const DATA_NAMESPACE = "data.componentSettings";

/**
 * @param  {Object} element 当前元素
 * @param  {Function} updateElement 修改属性后，调用此方法更新element
 */
const CardSettings = (props) => {
  const { updateElement, ele, parentEl } = props;
  const messages = getLocale();

  const { componentSettings = {}, formSettings = {} } = ele.data;
  const { label = "", name = "" } = formSettings;
  const { showArrow = true, bordered = true } = componentSettings;
  // const { getUpdateValue, getUpdatePreview } = useUpdateHandlers({
  //   element: ele,
  //   updateElement,
  //   dataNamespace: DATA_NAMESPACE,
  // });

  const initialValues = {
    align: "left",
    ellipsis: false,
    label,
    name,
    showArrow,
    bordered,
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const value = obj[key];
      const newElement = set(ele, propName, value);
      updateElement({
        element: newElement,
      });
    });
  };

  return (
    <React.Fragment>
      <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
        <Panel header={messages["PAGEBUIDER_SETTINGS"]} key="1">
          {parentEl.type !== "collapse" && (
            <Form
              {...toolFormAttr}
              initialValues={initialValues}
              onValuesChange={onFormChange}
            >
              <Form.Item
                label={messages["PAGEBUIDER_SETTINGS_BORDERED"]}
                name="bordered"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <GridSettings />
              <WidthSetting />
            </Form>
          )}
        </Panel>
      </Collapse>
    </React.Fragment>
  );
};

export default connect<any, any, any>(
  (state, { element }) => {
    const ele = getElementWithChildren(state, element.id);
    const parentEl = getParentElementWithChildren(state, element.id);
    return { ele, parentEl };
  },
  null,
  null,
  { areStatePropsEqual: isEqual }
)(CardSettings);
